import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType, StateObservable } from 'redux-observable';
import AppState from '../../state';
import { withLatestFrom, mergeMap } from 'rxjs/operators';
import * as collaborator from '@webapp/sdk/collaborators';
import * as artists from '@webapp/sdk/artists';
import { CREATE_ARTIST_COLLABORATOR } from '../actions';
import {
  CreateArtistCollaborator,
  CreateCollaboratorSuccess,
  CreateCollaboratorError,
} from '../action-creators';
import { collaboratorsList } from '../selectors';
import { NoOp } from '@webapp/store/ui/action-creators';

export const createArtistCollaboratorEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, CreateArtistCollaborator>(CREATE_ARTIST_COLLABORATOR),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      try {
        const artist = await artists.inviteArtist({
          name: action.name,
          externalProfile: action.externalArtist,
        });

        const currentCollabs = collaboratorsList(
          state.collaborator,
          action.newCollaborator.assetId
        );
        if (
          currentCollabs.some(
            (c) =>
              c.collaboratorId === artist.id &&
              c.collaboratorType === action.newCollaborator.collaboratorType
          )
        ) {
          return new NoOp();
        }

        const newCollaborator = await collaborator.create({
          ...action.newCollaborator,
          collaboratorId: artist.id,
        });

        return new CreateCollaboratorSuccess(
          newCollaborator,
          action.isReplicatingFromFirstTrack
        );
      } catch (err) {
        return new CreateCollaboratorError((err as Error).message);
      }
    })
  );
